"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Price = void 0;
var _culture = require("@ori/culture");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _hooks = require("../../../../hooks");
var _models = require("../../../../models");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Price = (param)=>{
    let { originalShippingFee, shippingFee } = param;
    const { getTestIdProps } = (0, _testidGenerator.default)();
    const { translations } = (0, _hooks.useTranslations)();
    const { culture, financialSet } = (0, _culture.useCulture)();
    const formattedPrice = (0, _react.useMemo)(()=>(0, _culture.formatCurrency)(shippingFee, culture, financialSet), [
        shippingFee,
        culture,
        financialSet
    ]);
    const originalFormattedPrice = (0, _react.useMemo)(()=>originalShippingFee === undefined ? undefined : (0, _culture.formatCurrency)(originalShippingFee, culture, financialSet), [
        culture,
        financialSet,
        originalShippingFee
    ]);
    const showOldPrice = originalShippingFee !== undefined && shippingFee < originalShippingFee;
    const useOfferColor = shippingFee === 0 || showOldPrice;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
        ...getTestIdProps(_models.TestId.PickupPointCardPrice),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.CurrentPrice, {
                useOfferColor: useOfferColor,
                ...getTestIdProps(_models.TestId.DeliveryFee),
                children: shippingFee === 0 ? translations.free : formattedPrice
            }),
            showOldPrice ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.OldPrice, {
                ...getTestIdProps(_models.TestId.OriginalDeliveryFee),
                children: originalFormattedPrice
            }) : null
        ]
    });
};
exports.Price = Price;
